export default __webpack_public_path__ + "media/images/user_photos/111-90022f805d434ddaa274159f8f401b4f.jpg";